export default __webpack_public_path__ + "static/media/avatar.4f6106da.png";